import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      width: 'available'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      width: 'available'
    },
    headBox: {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px',
      borderRadius: palette.borderRadius.default,
      gap: '10px',
      color: palette.text.primary,
      background: palette.background.underBox
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
